import type { Action } from '@/workflow-builder/_contract/command';

export const ACTION_CREATE_DRAFT_PREFIX = 'builder2-create-draft:';
export const ACTION_FINALIZE_TOOL_BINDINGS = 'builder2-finalize-tool-bindings';
export const ACTION_ADD_BRANCH_CASE = 'builder2-add-branch-case';
export const ACTION_BEGIN_BRANCH_DEFAULT_CASE = 'builder2-begin-branch-default-case';
export const ACTION_FINALIZE_DRAFT = 'builder2-finalize-draft';
export const ACTION_DISCARD_DRAFT = 'builder2-discard-draft';
export const ACTION_COMMIT_WORKFLOW = 'builder2-commit-workflow';
export const ACTION_DISCARD_WORKFLOW = 'builder2-discard-workflow';
export const ACTION_RUN_WORKFLOW = 'builder2-run-workflow';
export const ACTION_RUN_REMOTE = 'builder2-run-remote';
export const SECTION_RUNTIME_INPUT = 'builder-runtime-input';
export const ACTION_SUBMIT_RUNTIME_NATURAL = 'builder-runtime-submit-natural';
export const ACTION_SUBMIT_RUNTIME_TRUE = 'builder-runtime-submit-true';
export const ACTION_SUBMIT_RUNTIME_FALSE = 'builder-runtime-submit-false';
export const ACTION_DISPATCH_WORKFLOW = 'builder2-dispatch-workflow';
export const ACTION_BIND_EXTERNAL = 'builder2-bind-external';
export const ACTION_BIND_BOOLEAN_TRUE = 'builder2-bind-boolean-true';
export const ACTION_BIND_BOOLEAN_FALSE = 'builder2-bind-boolean-false';
export const ACTION_BIND_NATURAL = 'builder2-bind-natural';

export function resolveActionFromOverlayActionId(actionId: string): Action | undefined {
    if (actionId.startsWith(ACTION_CREATE_DRAFT_PREFIX)) {
        const stepKind = actionId.slice(ACTION_CREATE_DRAFT_PREFIX.length);
        if (stepKind === 'tool' || stepKind === 'branch' || stepKind === 'for' || stepKind === 'while') {
            return { command: 'create_draft', stepKind };
        }
        return undefined;
    }

    switch (actionId) {
        case ACTION_FINALIZE_TOOL_BINDINGS:
            return { command: 'finalize_current_tool_bindings' };
        case ACTION_ADD_BRANCH_CASE:
            return { command: 'add_branch_case' };
        case ACTION_BEGIN_BRANCH_DEFAULT_CASE:
            return { command: 'begin_branch_default_case' };
        case ACTION_FINALIZE_DRAFT:
            return { command: 'finalize_draft' };
        case ACTION_DISCARD_DRAFT:
            return { command: 'discard_draft' };
        case ACTION_COMMIT_WORKFLOW:
            return { command: 'commit_workflow' };
        case ACTION_DISCARD_WORKFLOW:
            return { command: 'discard_workflow' };
        case ACTION_RUN_WORKFLOW:
        case ACTION_RUN_REMOTE:
            return { command: 'run_workflow' };
        case ACTION_DISPATCH_WORKFLOW:
            return { command: 'dispatch_workflow' };
        case ACTION_BIND_EXTERNAL:
            return { command: 'bind_external_input_potential' };
        default:
            return undefined;
    }
}
